<div class="transport-entry" [ngClass]="{'selected' : selected}" matRipple>
  <sc-flex>
    <ng-container *ngIf="transport.plannedForAssignment">
      <sc-icon iconClass="fa-chevrons-left" style="color: red;"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
    </ng-container>
    <ng-container *ngIf="transport.automaticallyPlanned">
      <sc-icon iconClass="fa-robot"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
    </ng-container>
    <app-transport-scope-icon [scope]="transport.transport.scope"></app-transport-scope-icon>
    <div class="title">{{transport.transport.identifyingNumberplate}}</div>
    <sc-content-spacer grow></sc-content-spacer>
    <div class="duration">{{transport.transport.processing.processingTime}}</div>
  </sc-flex>
  <sc-content-spacer vertical [half]="true"></sc-content-spacer>
  <sc-flex>
    <div class="carrier">{{transport.transport.masterdata.carrier}}</div>
  </sc-flex>
  <sc-content-spacer vertical [half]="true"></sc-content-spacer>
  <sc-flex>
    <ng-container
      *ngIf="transport?.transport?.timing?.planningDate && !transport?.transport?.nextPosition?.firstTimeSlotStart && !transport?.transport?.nextPosition?.lastTimeSlotEnd">
      <sc-icon iconClass="fa-calendar"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
      {{transport?.transport?.timing.planningDate | timestamp }}
      <ng-container *ngIf="transport?.transport?.timing?.timeSlotDelay">(+{{transport?.transport?.timing?.timeSlotDelay}})
      </ng-container>
    </ng-container>
    <ng-container
      *ngIf="transport?.transport?.nextPosition?.firstTimeSlotStart && transport?.transport?.nextPosition?.lastTimeSlotEnd">
      <sc-icon iconClass="fa-calendar"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
      {{transport?.transport?.nextPosition.firstTimeSlotStart | timestamp:['optimizeToday'] }} -
      {{transport?.transport?.nextPosition.lastTimeSlotEnd | timestamp:['timeonly'] }}
      <ng-container *ngIf="transport?.transport?.timing.timeSlotDelay">(+{{transport?.transport?.timing.timeSlotDelay}})
      </ng-container>
    </ng-container>
    <sc-content-spacer grow></sc-content-spacer>

    <div class="status-icon" *ngIf="transport.transport.masterdata.important">
      <sc-icon iconClass="fa-exclamation"></sc-icon>
    </div>
    <div class="status-icon" *ngIf="transport.transport.masterdata.dangerousGoods">
      <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
    </div>
    <div class="status-icon" *ngIf="transport.transport.processing.pendingTaskState !== TransportTaskStatus.NONE">
      <app-task-state-icon [state]="transport.transport.processing.pendingTaskState"></app-task-state-icon>
    </div>
    <div class="status-icon" *ngIf="transport.transport.masterdata.urgent">
      <sc-icon iconClass="fa-truck-fast"></sc-icon>
    </div>
    <div class="status-icon" *ngIf="transport.transport.processing.inUmbrueckung">
      <sc-icon iconClass="fa-random"></sc-icon>
    </div>
  </sc-flex>
  <sc-flex>
  </sc-flex>
</div>
